

















import Vue from 'vue'

export default Vue.extend({
  name: 'ShiftEditDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSerieClick (): void {
      this.$emit('serie')
    },

    onShiftClick (): void {
      this.$emit('shift')
    }
  }
})
